import { Link } from 'react-router-dom';
import { Icon } from '@/components/Icon';

export function NotFoundView() {
  return (
    <div className="empty-state">
      <Icon name="search" size={32} />
      <p className="empty-state__title">Page not found</p>
      <p className="muted">That view doesn’t exist — it may have moved.</p>
      <Link to="/mail" className="btn">
        Back to Mail
      </Link>
    </div>
  );
}
